import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const BoostJobSection = ({jesData}) => {
    const navigate = useNavigate();
  return (
    <div className="mt-4 flex w-full flex-col items-center justify-center rounded-lg border-[1px] border-[#CCCCCC] py-4 px-3 md:w-2/5">
      <button
        className="w-full rounded-3xl bg-gradient-to-r from-[#13A0BD] to-[#086788] py-3 text-white"
        onClick={() => {
          // Mixpanel.track(Constants.Mixpanel.JES_ENTRY_CERTIFICATE_ICON, {
          //   distinct_id: email,
          // });
          // navigate("/my-profile/user");
          navigate("/my-profile/user");
        }}
      >
        Boost My Job Score
      </button>
      <div className="mt-4 flex flex-col self-start py-1">
        <div className="mt-2 flex items-center justify-start">
          <FontAwesomeIcon
            icon={faCheck}
            className="text-md rounded-md border-[1px] border-[#CCCCCC]  bg-white px-1 py-1 text-[#1CB05E]"
          />
          <span className="ml-2 whitespace-nowrap text-sm">
            Increase Score By{" "}
            <span className={`font-medium text-[#818CF8]`}>
              {jesData?.delta_score}%
            </span>{" "}
            for this Micro-Skill
          </span>
        </div>
        <div className="mt-2 flex items-center justify-start">
          <FontAwesomeIcon
            icon={faCheck}
            className="text-md rounded-md border-[1px] border-[#CCCCCC]  bg-white px-1 py-1 text-[#1CB05E]"
          />
          <span className="ml-2 text-sm ">Unlimited Free Certifications</span>
        </div>
        <div className="mt-2 flex items-center justify-start">
          <FontAwesomeIcon
            icon={faCheck}
            className="text-md rounded-md border-[1px] border-[#CCCCCC]  bg-white px-1 py-1 text-[#1CB05E]"
          />
          <span className="ml-2 whitespace-nowrap text-sm ">
            Access to All 200+ Courses
          </span>
        </div>
        <div className="mt-2 flex items-center justify-start">
          <FontAwesomeIcon
            icon={faCheck}
            className="text-md rounded-md border-[1px] border-[#CCCCCC]  bg-white px-1 py-1 text-[#1CB05E]"
          />
          <span className="ml-2 whitespace-nowrap text-sm ">
            Projects & Placement Support
          </span>
        </div>
      </div>
    </div>
  );
};

export default BoostJobSection;
